import { FILTER_DISPLAY } from "@/modules/Dashboards/AdminDashboard/constants/AdminDashboardConstants";
import { Filter } from "@/modules/Dashboards/AdminDashboard/models/Filter";
import { SecondaryFilter } from "@/modules/Dashboards/AdminDashboard/models/SecondaryFilter";
import {
  DATE_OPERATORS,
  OPERATORS_FILTERS
} from "@/shared/constants/GeneralConstants";

export const DOCUMENT = {
  LIST_EMPTY_STATE: {
    HEADER: "No hay información para mostrar",
    PARAGRAPH: "Realiza una búsqueda para encontrar nueva información"
  },
  FIELDS: {
    TYPE: "Tipo",
    NAME: "Nombre",
    CATEGORY: "Categoría",
    SUB_CATEGORY: "Sub Categoría"
  },
  EVENT: {
    SHOW: "showDocument",
    SHARE: "shareDocument",
    EDIT: "editDocument",
    DELETE: "deleteDocument",
    CLOSE_PREVIEW: "closePreview",
    ADD_DOCUMENT: "addDocument"
  },
  PROP_DEFAULT: {
    PREV_NAME: "Previsualizacion"
  },
  LABEL: {
    TEMPLATES: ["{{1}}", "{{2}}"],
    SHARE: {
      EMAIL: "Correo"
    },
    BUTTON: {
      ADD: "Agregar documento"
    }
  },
  MESSAGE: {
    NO_MORE_DATA: "No hay más datos para cargar",
    FORBIDDEN: "Solicita permisos para cargar la información de correo",
    EMPTY_URL: "No se encontró url del documento",
    SHARE: "Compartir Documento",
    SHARE_MESSAGE: "Elige una opción para compartir el documento",
    DELETE_DIALOG_TITLE: "Eliminar archivo",
    DELETE_DIALOG_TEXT: "¿Desea eliminar el archivo de forma permanente?",
    ERROR_TO_GET_URL: "Hubo un error al obtener la url del documento"
  },
  EMPTY_STATE: {
    HEADER: "Documento no encontrado",
    PARAGRAPH:
      "No se pudo visualizar debido a que hubo un error con la URL del documento"
  }
};

export const GOOGLE_DRIVE_URL =
  "https://drive.google.com/viewerng/viewer?embedded=true&url=";

export const DOCUMENT_FILTERS: SecondaryFilter[] = [
  {
    name: "Fecha de creación",
    key: "dateCreated",
    avatar: "mdi-calendar-month",
    type: "all",
    disabled: true,
    operators: DATE_OPERATORS,
    display: FILTER_DISPLAY.DATE
  },
  {
    name: "Categoría",
    key: "category",
    avatar: "mdi-folder",
    type: "all",
    disabled: true,
    operators: OPERATORS_FILTERS,
    display: FILTER_DISPLAY.LIST
  },
  {
    name: "Sub categoría",
    key: "subCategory",
    avatar: "mdi-folder",
    type: "all",
    disabled: true,
    operators: OPERATORS_FILTERS,
    display: FILTER_DISPLAY.LIST
  }
];

export const DOCUMENTS_ACCESS = {
  GET: "consultar documentos",
  POST: "crear documentos",
  PUT: "modificar documentos",
  DELETE: "eliminar documentos"
};

export const DOCUMENT_SECONDARY_FILTERS: SecondaryFilter[] = [
  {
    name: "Nombre",
    placeholder: "Nombre de Documento",
    key: "name",
    avatar: "mdi-form-textbox",
    type: "secondaryFilter",
    disabled: true,
    operators: OPERATORS_FILTERS,
    display: FILTER_DISPLAY.UNIQUE,
    notSelect: ["dateCreated"],
    default: true
  },
  {
    name: "Fecha de creación",
    key: "dateCreated",
    avatar: "mdi-calendar-month",
    type: "all",
    disabled: true,
    operators: DATE_OPERATORS,
    notSelect: ["name"],
    display: FILTER_DISPLAY.DATE
  },
  {
    name: "Categoría",
    placeholder: "Categoría de Documento",
    key: "category",
    avatar: "mdi-folder",
    type: "all",
    disabled: true,
    operators: OPERATORS_FILTERS,
    display: FILTER_DISPLAY.LIST,
    multipleOff: true,
    childrenReload: ["subCategory"]
  },
  {
    name: "Sub categoría",
    placeholder: "Sub categoría de Documento",
    key: "subCategory",
    avatar: "mdi-folder",
    type: "all",
    disabled: true,
    operators: OPERATORS_FILTERS,
    display: FILTER_DISPLAY.LIST,
    multipleOff: true,
    options: []
  }
];

export const DOCUMENT_FORM_FILTERS: Filter[] = [
  {
    mainFilterKey: "documents",
    mainFilterName: "Todos",
    avatar: "mdi-animation",
    initial: true,
    secondaryFilters: DOCUMENT_SECONDARY_FILTERS
  }
];

export const IMAGE_EXTENSIONS = [
  "jpg",
  "jpeg",
  "png",
  "gif",
  "bmp",
  "svg",
  "tiff"
];
export const PDF_EXTENSIONS = ["pdf"];
export const VIDEO_EXTENSIONS = ["mp4", "avi", "wmv", "flv", "mkv", "mov"];
export const AUDIO_EXTENSIONS = ["mp3", "wav", "aac", "flac", "ogg"];
export const OFFICE_EXTENSIONS = ["doc", "docx", "xls", "xlsx", "ppt", "pptx"];

export const VIDEO_TYPE = "video";
export const IMAGE_TYPE = "image";
export const PDF_TYPE = "pdf";
export const AUDIO_TYPE = "audio";
export const OFFICE_TYPE = "office document";
export const URL_TYPE = "url";

export const DOCLIST_ID = "docListElement";

export const DOWNLOAD_ONLY_CATEGORY = "downloadOnly";
export const DOWNLOAD_ONLY_FLAG = "/?downloadOnly";
